export const LINK_PMS = {
    reservationList: `${process.env.VUE_APP_URL_PMS}/reservation/reservation-list`,
    linkContractDetail: `${process.env.VUE_APP_URL_PMS}/reservation/contract-detail`, // id, type, tab=basic-information
    linkReservationCalendar: `${process.env.VUE_APP_URL_PMS}/reservation/calendar` // reservation/calendar?id=1
}
